"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCheckoutPayment = exports.checkoutPaymentContext = exports.CheckoutPaymentProvider = void 0;
var _react = require("react");
var _types = require("../types");
const checkoutPaymentContext = exports.checkoutPaymentContext = /*#__PURE__*/ (0, _react.createContext)(_types.DEFAULT_CONFIG);
const CheckoutPaymentProvider = exports.CheckoutPaymentProvider = checkoutPaymentContext.Provider;
const useCheckoutPayment = ()=>(0, _react.useContext)(checkoutPaymentContext);
exports.useCheckoutPayment = useCheckoutPayment;
